import React from 'react'

const PointsDetailsScreen = () => {
  return (
    <div>PointsDetailsScreen</div>
  )
}

export default PointsDetailsScreen